import { render, staticRenderFns } from "./MainMEPFServiceItem.vue?vue&type=template&id=f530bb1a&"
import script from "./MainMEPFServiceItem.vue?vue&type=script&lang=js&"
export * from "./MainMEPFServiceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports